<div class="row move__row">
  <div class="col-12 offset-lg-2 col-lg-8 move__header">
    <h3 class="move__intro" *appApplyIfNotEmpty="translationService.getTranslation('move_intro')"
        [innerHTML]="translationService.getTranslation('move_intro')"></h3>
  </div>
  <div class="col-12 offset-lg-2 col-lg-8 move__description">
    <p class="move__description-text" [innerHTML]="translationService.getTranslation('move_description')"></p>
  </div>
</div>
<div class="row">
  <div class="col-12 offset-lg-2 col-lg-8">
    <mat-card class="mt-3 mat-mdc-card-outlined move__card">
      <mat-card-content class="move__card-content">
        <div class="--row move__content-row">
          <div class="--col-12 move__content-col">
            @if (isLoadingUserData || isLoadingMoves || saveInProcess) {
              <div class="move__loading" style="text-align: center;">
                <app-loading-spinner class="move__loading-spinner"></app-loading-spinner>
              </div>
            }
            @if (!isLoadingUserData && !isLoadingMoves && !saveInProcess) {
              @if (moves?.length > 0) {
                <h5 class="mt-5 move__existing-move-headline"
                    *appApplyIfNotEmpty="translationService.getTranslation('move_existingMoveHeadline')"
                    [innerHTML]="translationService.getTranslation('move_existingMoveHeadline')"></h5>
                <div class="col-12 mb-3 move__existing-move-intro"
                     [innerHTML]="translationService.getTranslation('move_existingMoveIntro')">
                </div>
                @for (move of moves; track move; let i = $index) {
                  <div class="form-group col-12 move__move-item">
                    <div class="row move__move-row">
                      <div class="col-6 move__move-label" [innerHTML]="translationService.getTranslation('startdate')">
                      </div>
                      <div class="col-6 move__move-value">
                        {{ move.validDate.validFrom | date: translationService.getTranslation('dateFormat') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 move__move-item">
                    <div class="row move__move-row">
                      <div class="col-6 move__move-label" [innerHTML]="translationService.getTranslation('name')">
                      </div>
                      <div class="col-6 move__move-value">
                        {{ move.person.addressCodeDescription + " " + (move.person.firstname ? move.person.firstname + ' ' : '') + " " + move.person.lastname }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 move__move-item">
                    <div class="row move__move-row">
                      <div class="col-6 move__move-label" [innerHTML]="translationService.getTranslation('address_street')">
                      </div>
                      <div class="col-6 move__move-value">
                        {{ move.address.street }} {{ move.address.houseno | houseNoPipe }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 move__move-item">
                    <div class="row move__move-row">
                      <div class="col-6 move__move-label"
                           [innerHTML]="translationService.getTranslation('address_postcode')">
                      </div>
                      <div class="col-6 move__move-value">
                        {{ move.address.zipcode }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 move__move-item">
                    <div class="row move__move-row">
                      <div class="col-6 move__move-label" [innerHTML]="translationService.getTranslation('address_city')">
                      </div>
                      <div class="col-6 move__move-value">
                        {{ move.address.city }}
                      </div>
                    </div>
                  </div>
                }
              }
              <ng-container>
                <h5 class="move__personaldata-headline"
                    *appApplyIfNotEmpty="translationService.getTranslation('label_personalData')"
                    [innerHTML]="translationService.getTranslation('label_personalData')"></h5>
                <div class="form-group col-12 move__personaldata-item">
                  <div class="row move__personaldata-row">
                    <div class="col-5 move__personaldata-label" [innerHTML]="translationService.getTranslation('name')">
                    </div>
                    <div class="col-7 move__personaldata-value">
                      {{ userData?.person.addressCodeDescription ? userData?.person.addressCodeDescription : userData?.person.addressCode }} {{ userData?.person.titleDescription }} {{ userData?.person.firstname }} {{ userData?.person.lastname }}
                    </div>
                  </div>
                </div>
                @if (userData?.birthday != null) {
                  <div class="form-group col-12 move__personaldata-item">
                    <div class="row move__personaldata-row">
                      <div class="col-5 move__personaldata-label"
                           [innerHTML]="translationService.getTranslation('address_birthday')">
                      </div>
                      <div class="col-7 move__personaldata-value">
                        {{ userData?.birthday | date: translationService.getTranslation('dateFormat') }}
                      </div>
                    </div>
                  </div>
                }
                <div class="form-group col-12 move__personaldata-item">
                  <div class="row move__personaldata-row">
                    <div class="col-5 move__personaldata-label"
                         [innerHTML]="translationService.getTranslation('label_backendid')">
                    </div>
                    <div class="col-7 move__personaldata-value">
                      {{ userData?.userBackendId }}
                    </div>
                  </div>
                </div>
                <h5 class="mt-5 move__current-headline"
                    *appApplyIfNotEmpty="translationService.getTranslation('move_current')"
                    [innerHTML]="translationService.getTranslation('move_current')"></h5>
                <div class="form-group col-12 move__current-item">
                  <div class="row move__current-row">
                    <div class="col-5 move__current-label"
                         [innerHTML]="translationService.getTranslation('address_street')">
                    </div>
                    <div class="col-7 move__current-value">
                      {{ userData?.address.street }} {{ userData?.address.houseno | houseNoPipe }}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 move__current-item">
                  <div class="row move__current-row">
                    <div class="col-5 move__current-label"
                         [innerHTML]="translationService.getTranslation('address_postcode')">
                    </div>
                    <div class="col-7 move__current-value">
                      {{ userData?.address.zipcode }}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 move__current-item">
                  <div class="row move__current-row">
                    <div class="col-5 move__current-label" [innerHTML]="translationService.getTranslation('address_city')">
                    </div>
                    <div class="col-7 move__current-value">
                      {{ userData?.address.city }}
                    </div>
                  </div>
                </div>
                @if (userData?.phoneList && userData?.phoneList.length > 0 ||
                      userData?.mobileList && userData?.mobileList.length > 0 ||
                      userData?.emailList && userData?.emailList.length > 0) {
                  <h5 class="mt-5 move__contactdata-headline"
                      [innerHTML]="translationService.getTranslation('label_contactData')"></h5>
                }
                @if (userData?.phoneList && userData?.phoneList.length > 0) {
                  <div class="form-group col-12 move__contactdata-item">
                    <div class="row move__contactdata-row">
                      <div class="col-5 move__contactdata-label"
                           [innerHTML]="translationService.getTranslation('address_telephone')">
                      </div>
                      <div class="col-7 move__contactdata-value">
                        <ul style="padding-left: 0; list-style: none;">
                          @for (phone of userData?.phoneList; track phone) {
                            <li>{{ phone.prefixNumber }} / {{ phone.telNumber }}</li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                }
                @if (userData?.mobileList && userData?.mobileList.length > 0) {
                  <div class="form-group col-12 move__contactdata-item">
                    <div class="row move__contactdata-row">
                      <div class="col-5 move__contactdata-label"
                           [innerHTML]="translationService.getTranslation('address_mobil')">
                      </div>
                      <div class="col-7 move__contactdata-value">
                        <ul style="padding-left: 0; list-style: none;">
                          @for (mobile of userData?.mobileList; track mobile) {
                            <li>{{ mobile.prefixNumber + ' / ' + mobile.telNumber }}</li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                }
                @if (userData?.emailList && userData?.emailList.length > 0) {
                  <div class="form-group col-12 move__contactdata-item">
                    <div class="row move__contactdata-row">
                      <div class="col-5 move__contactdata-label"
                           [innerHTML]="translationService.getTranslation('address_email')">
                      </div>
                      <div class="col-7 move__contactdata-value">
                        <ul style="padding-left: 0; list-style: none;">
                          @for (mail of userData?.emailList; track mail) {
                            <li>{{ mail }}</li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                }
                <app-general-errors class="move__errors" [errors]="errorsArr"></app-general-errors>

                @if (movePossibilityCheckInProgress()) {
                  <div class="move__loading" style="text-align: center;">
                    <app-loading-spinner class="move__loading-spinner"></app-loading-spinner>
                  </div>
                }

                @if (!moves || moves?.length == 0 && movePossible() && !movePossibilityCheckInProgress()) {
                  <h5 class="mt-5 move__newaddress-headline"
                      *appApplyIfNotEmpty="translationService.getTranslation('label_newAddress')"
                      [innerHTML]="translationService.getTranslation('label_newAddress')"></h5>
                  <app-hup-subscription-address class="move__newaddress-form" [showActivateCheckbox]="false"
                                                [controlGroup]="addressForm"
                                                [showValidFrom]="true"
                                                [isMobile]="isMobile"
                                                [minDate]="minDate">
                  </app-hup-subscription-address>
                  @if (priceChecked) {
                    <div class="alert alert-warning row mb-2 mt-3 move__price-warning">
                      @for (price of movePrice; track price) {
                        <div class="col-12 move__price-info">
                          <div [innerHTML]="price.infoText" class="move__price-info-text">
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="col-12 mt-3 move__actions">
                    @if (!priceChecked && !priceCheckInProcess) {
                      <button class="me-3 move__action-check" mat-raised-button color="primary" (click)="onCheckMove()"
                              [innerHTML]="translationService.getTranslation('button_check_price_move')"></button>
                    }
                    @if (priceChecked && !priceCheckInProcess) {
                      <button mat-raised-button color="primary" [hidden]="saveInProcess" (click)="onSendMove()"
                              class="move__action-send"
                              [innerHTML]="translationService.getTranslation('button_send')"></button>
                    }
                    @if (priceCheckInProcess || saveInProcess || movePossibilityCheckInProgress()) {
                      <div class="move__loading" style="text-align: center;">
                        <app-loading-spinner class="move__loading-spinner"></app-loading-spinner>
                      </div>
                    }
                  </div>
                } @else if (!movePossible()) {
                  <div class="col-12 mt-3 alert alert-warning">
                    <div [innerHTML]="translationService.getTranslation('move_impossible')" class="move__notpossible-text mb-3"></div>
                    @if (showToContactFormButton) {
                      <button mat-raised-button color="primary" (click)="navigateToContactForm()"
                              class="move__action-send" [innerHTML]="translationService.getTranslation('move_ToContactForm')"></button>
                    }
                  </div>
                }
              </ng-container>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
